module.exports = __webpack_public_path__ + "img/Flag_of_France (1).adfc9bcf.svg";